document.addEventListener('DOMContentLoaded', function () {
    const submenuTriggers = document.querySelectorAll('.submenu-trigger');
    const backButtons = document.querySelectorAll('.ml-mobile-menu_back-button');
  const mobileMenu = document.querySelector("#ml-mobile-menu");
    submenuTriggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const subItemsList = this.closest('.menu-item').querySelector('.sub-menu');



    let totalHeight = 0;
    Array.from(subItemsList.children).forEach(child => {
        totalHeight += child.offsetHeight
    })
  mobileMenu.style.height = totalHeight + 'px';
            // Toggle the expanded class for transition
            subItemsList.classList.toggle('expanded');
        });
    });

    backButtons.forEach(backButton => {
        backButton.addEventListener('click', function () {
          
            const subMenu = this.closest('.sub-menu');
           const subItemsList = this.parentNode.parentNode.parentNode.parentNode;
let totalHeight = 0;
    Array.from(subItemsList.children).forEach(child => {
        totalHeight += child.offsetHeight
    })
  mobileMenu.style.height = totalHeight + 'px';
console.log(subItemsList);
            // Toggle the expanded class for transition
            subMenu.classList.toggle('expanded');
        });
    });
});